import { getNations } from "../../../../shared/functions/fns.misc";
import LoaderView from "@phoenixreisen/mithrils/src/loader";
import CustomerForm from "./form.customer.m";
import AdressForm from "./form.address.m";
import Stream from "mithril/stream";
import Model from "../../model";
import m from "mithril";
const Loader = LoaderView;
function toggleForms(answer, state) {
    Model.resetFields();
    state.showCustomerForm(answer === "1");
    state.showAddressForm(answer === "2");
}
export default {
    oninit({ state }) {
        state.showSuccess = Stream(false);
        state.showAddressForm = Stream(false);
        state.showCustomerForm = Stream(false);
        getNations()
            .then((result) => {
            Model.nations = result;
        })
            .finally(() => {
            m.redraw();
        });
        Model.getCatalog(m.route.param("key"))
            .then((result) => {
            Model.catalog = result;
        })
            .catch(() => {
            location.href = process.env.API_ERROR;
        })
            .finally(() => {
            m.redraw();
        });
    },
    view({ state }) {
        const { catalog, webtexte } = Model;
        const { showSuccess, showCustomerForm, showAddressForm } = state;
        if (!catalog) {
            return m(Loader, { text: "Katalog wird geladen..." });
        }
        return (m("article", { class: "catalog-form" },
            m("div", { class: "catalog-form__intro" },
                m("div", { class: "catalog-form__img" },
                    m("img", { src: catalog["bestellungconfig/img-url"] })),
                m("div", { class: "mb2" },
                    m("div", null,
                        m("strong", null, m.trust(catalog["bestellungconfig/katalog-titel"]))),
                    m("hr", null),
                    m("p", null, m.trust(catalog["bestellungconfig/ueberschrift"])),
                    m("div", null, m.trust(catalog["bestellungconfig/html-freitext"])))),
            !showSuccess() ? (m("div", { class: "form-box" },
                m("div", null,
                    m("label", { class: "select" },
                        m("select", { onchange: (e) => toggleForms(e.target.value, state) },
                            m("option", { value: "" }, "Bitte ausw\u00E4hlen"),
                            m("option", { value: 1 }, "Ja"),
                            m("option", { value: 2 }, "Nein")),
                        m("span", { class: "select__label" }, "Ich bin bereits Phoenix-Kunde"))),
                m(CustomerForm, { catalog: catalog, showForm: showCustomerForm, showAddressForm: showAddressForm }),
                m(AdressForm, { catalog: catalog, nations: Model.nations, showSuccess: showSuccess, showForm: showAddressForm, showCustomerForm: showCustomerForm }))) : (""),
            showSuccess() ? (m("div", { class: "alert alert--icon alert--success" },
                m("i", { class: "fas fa-check" }),
                m("div", null, m.trust(webtexte["katalogbestellung__erfolg"] ||
                    `Et voilà, der Katalog ist so gut wie unterwegs zu Ihnen.
                            Vielen Dank. Wir wünschen Ihnen viel Spaß beim Stöbern!
                            Sie können dieses Fenster schließen.`)))) : ("")));
    },
};
